import React, { FC, memo, useContext, useEffect } from 'react';

import { ResultContext } from '../../context/result-context';

import Content from '../../components/content';

import ResultSuccess from './result-success';
import ResultFail from './result-fail';

import './result.scss';

interface ResultProps {}

const Result: FC<ResultProps> = memo(() => {
  const { currentResult } = useContext(ResultContext);
  const isRight = currentResult > 39 ? true : false;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  return (
    <div className="result">
      <Content className={`${isRight ? '-blue' : '-red'}`} isInner={true}>
        <div className="result__title">
          Ваш результат
          <span>{currentResult} из 50</span>
        </div>

        { isRight
          ? <ResultSuccess />
          : <ResultFail />
        }
      </Content>
	  </div>
  );
});

export default Result;
